import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { textOneLines } from "../../../../utils/styles";
import {
  BGColor02,
  blackColor,
  blueColor04,
  mobilePrimary,
  whiteColor,
} from "../../../../configs/styles/muiThemes";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import ModalCard from "../../../../components/ModalCard";

const CustomerInstructions = ({ customerNotes }) => {
  const [openPopup, setOpenPopup] = useState(false);
  return (
    <>
      <Box display="flex" alignItems="center" gap="5px">
        <TipsAndUpdatesOutlinedIcon
          sx={{ fontSize: "17px", color: blueColor04 }}
        />

        <Typography
          variant="p"
          fontSize={12}
          fontWeight={600}
          color={blueColor04}
          lineHeight="18px !important"
          sx={{
            ...textOneLines,
            textDecoration: "underline",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "none",
            },
          }}
          onClick={() => {
            setOpenPopup(true);
          }}
        >
          Customer Instructions
        </Typography>
      </Box>

      <ModalCard
        open={openPopup}
        handleClose={() => {
          setOpenPopup(false);
        }}
        width="40%"
      >
        <Box overflow="hidden" borderRadius="15px">
          <Box sx={{ bgcolor: whiteColor }}>
            <Box
              sx={{
                fontSize: 17,
                fontWeight: 600,
                lineHeight: "28px",
                bgcolor: BGColor02,
                p: "10px 15px",
                textAlign: "center",
              }}
            >
              Customer Instructions
            </Box>

            <Box
              sx={{
                fontSize: 13.5,
                fontWeight: 600,
                color: blackColor,
                lineHeight: "25px",
                p: "15px 15px 20px",
                textAlign: "center",
              }}
            >
              {customerNotes || "N/A"}
            </Box>

            <Box
              display="flex"
              justifyContent="center"
              bgcolor={BGColor02}
              p="10px 15px"
            >
              <Button
                variant="contained"
                disableElevation
                sx={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: whiteColor,
                  p: "6px 25px",
                  bgcolor: { xs: mobilePrimary, md: blueColor04 },
                  border: {
                    xs: `1px solid ${mobilePrimary}`,
                    md: `1px solid ${blueColor04}`,
                  },
                  borderR: "5px",
                  "&:hover": {
                    color: { xs: mobilePrimary, md: blueColor04 },
                    bgcolor: whiteColor,
                  },
                }}
                onClick={() => setOpenPopup(false)}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </ModalCard>
    </>
  );
};

export default CustomerInstructions;
